<template>
    <div class="filters row d-flex justify-content-start align-items-center">
        <div class="title-filter col-12 col-xl-auto pr-1"><span>FILTER :</span></div>
        <div class="col-12 col-md-3 col-xl-auto pr-1 px-xl-1 d-flex justify-content-center">
            <ForecastStatus @click="$emit('click', -1);" :class="['filter', filter.find(s => s === 'ALL') ? 'active' : '']" :status="-1" />
        </div>
        <div v-for="status in availableStatus" :key="status" class="col-12 col-md-3 col-xl-auto pr-1 px-xl-1 d-flex justify-content-center">
            <ForecastStatus
                @click="$emit('click', status);"
                :class="['filter', filter.find(s => s === status) ? 'active' : '']"
                :status="status"
                :key="status"
            />
        </div>
        <div v-if="hasAccessByProfile(PROFILES.FORECAST_MANAGER)" class="col-12 col-md-3 col-xl-auto pr-1 px-xl-1 d-flex justify-content-center">
            <ForecastStatus
                @click="$emit('click', 'DELETE');"
                :class="['filter', filter.find(s => s === 'DELETE') ? 'active' : '']"
                :status="'DELETE'"
            />
        </div>
    </div>
</template>
<script>
import { FORECAST_STATUS } from "@/components/forecasts/constants";
import ForecastStatus from "@/components/forecasts/elements/ForecastStatus";
import { PROFILES } from "@/plugins/AccessUserPlugin";

export default {
    components: {
        ForecastStatus
    },
    props: ["filter"],
    data() {
        return {
            FORECAST_STATUS,
            PROFILES
        };
    },
    computed: {
        availableStatus() {
            if (this.$accessUser.hasAccessByProfile(PROFILES.FORECAST_MANAGER)) {
                return FORECAST_STATUS;
            } else {
                return { PENDING: FORECAST_STATUS.PENDING, ACTIVE: FORECAST_STATUS.ACTIVE, CLOSED: FORECAST_STATUS.CLOSED };
            }
        }
    }
};
</script>
<style scoped lang="scss">
//@import "../../../assets/css/themes";
.title-filter {
    span {
        font-weight: 400;
        font-size: 18px;
        padding: 0 5px 0 0;
        font-family: Oswald, Sans-Serif;
    }
}
.filter {
    width: 140px;
    border-width: 2px !important;
    transition: 0.3s ease-in-out;
    &.active {
        border-color: #333 !important;
        box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.3);
    }

    &:hover {
        box-shadow: 0 0 11px rgba(0, 0, 0, 0.3);
    }
}
</style>



// WEBPACK FOOTER //
// ForecastFilters.vue?4591ca8b